<template>
  <!-- Products Grid-->
      <section class="bg-secondary padding-top-3x padding-bottom-2x margin-top-3x">
        <div class="container">
          <h3 class="text-center mb-30">Explore Watches</h3>
          <ul class="nav nav-pills justify-content-center pb-2">
            <li class="nav-item"><a class="nav-link active" href="#" data-filter="*">All</a></li>
            <li class="nav-item"><a class="nav-link" href="#" data-filter=".classic">Classic</a></li>
            <li class="nav-item"><a class="nav-link" href="#" data-filter=".digital">Digital</a></li>
            <li class="nav-item"><a class="nav-link" href="#" data-filter=".prestige">Prestige</a></li>
            <li class="nav-item"><a class="nav-link" href="#" data-filter=".sport">Sport</a></li>
          </ul>
          <div class="isotope-grid filter-grid cols-4 mt-4">
            <div class="gutter-sizer"></div>
            <div class="grid-sizer"></div>
            <!-- Product-->
            <div class="grid-item classic">
              <div class="product-card"><a class="product-thumb" href="shop-single.html">
                <img src="static/img/shop/products/17.jpg" alt="Product"></a>
                <h3 class="product-title"><a href="shop-single.html">Gents BN0024 Classic</a></h3>
                <h4 class="product-price">€185.00</h4>
                <div class="product-buttons">
                  <button class="btn btn-outline-secondary btn-sm btn-wishlist" data-toggle="tooltip" title="Whishlist"><i class="icon-heart"></i></button>
                  <button class="btn btn-outline-primary btn-sm" data-toast data-toast-type="success" data-toast-position="topRight" data-toast-icon="icon-circle-check" data-toast-title="Product" data-toast-message="successfuly added to cart!">Add to Cart</button>
                </div>
              </div>
            </div>
            <!-- Product-->
            <div class="grid-item digital">
              <div class="product-card"><a class="product-thumb" href="shop-single.html"><img src="static/img/shop/products/21.jpg" alt="Product"></a>
                <h3 class="product-title"><a href="shop-single.html">Gents BN0106 Digital </a></h3>
                <h4 class="product-price">€655.00</h4>
                <div class="product-buttons">
                  <button class="btn btn-outline-secondary btn-sm btn-wishlist" data-toggle="tooltip" title="Whishlist"><i class="icon-heart"></i></button>
                  <button class="btn btn-outline-primary btn-sm" data-toast data-toast-type="success" data-toast-position="topRight" data-toast-icon="icon-circle-check" data-toast-title="Product" data-toast-message="successfuly added to cart!">Add to Cart</button>
                </div>
              </div>
            </div>
            <!-- Product-->
            <div class="grid-item prestige">
              <div class="product-card"><a class="product-thumb" href="shop-single.html"><img src="static/img/shop/products/25.jpg" alt="Product"></a>
                <h3 class="product-title"><a href="shop-single.html">Gents BN0095 Prestige</a></h3>
                <h4 class="product-price">€725.00</h4>
                <div class="product-buttons">
                  <button class="btn btn-outline-secondary btn-sm btn-wishlist" data-toggle="tooltip" title="Whishlist"><i class="icon-heart"></i></button>
                  <button class="btn btn-outline-primary btn-sm" data-toast data-toast-type="success" data-toast-position="topRight" data-toast-icon="icon-circle-check" data-toast-title="Product" data-toast-message="successfuly added to cart!">Add to Cart</button>
                </div>
              </div>
            </div>
            <!-- Product-->
            <div class="grid-item classic">
              <div class="product-card"><a class="product-thumb" href="shop-single.html"><img src="static/img/shop/products/19.jpg" alt="Product"></a>
                <h3 class="product-title"><a href="shop-single.html">Gents BN0211 Classic</a></h3>
                <h4 class="product-price">€350.00</h4>
                <div class="product-buttons">
                  <button class="btn btn-outline-secondary btn-sm btn-wishlist" data-toggle="tooltip" title="Whishlist"><i class="icon-heart"></i></button>
                  <button class="btn btn-outline-primary btn-sm" data-toast data-toast-type="success" data-toast-position="topRight" data-toast-icon="icon-circle-check" data-toast-title="Product" data-toast-message="successfuly added to cart!">Add to Cart</button>
                </div>
              </div>
            </div>
            <!-- Product-->
            <div class="grid-item digital">
              <div class="product-card"><a class="product-thumb" href="shop-single.html"><img src="static/img/shop/products/22.jpg" alt="Product"></a>
                <h3 class="product-title"><a href="shop-single.html">Gents BN0076 Digital</a></h3>
                <h4 class="product-price">€225.00</h4>
                <div class="product-buttons">
                  <button class="btn btn-outline-secondary btn-sm btn-wishlist" data-toggle="tooltip" title="Whishlist"><i class="icon-heart"></i></button>
                  <button class="btn btn-outline-primary btn-sm" data-toast data-toast-type="success" data-toast-position="topRight" data-toast-icon="icon-circle-check" data-toast-title="Product" data-toast-message="successfuly added to cart!">Add to Cart</button>
                </div>
              </div>
            </div>
            <!-- Product-->
            <div class="grid-item sport">
              <div class="product-card"><a class="product-thumb" href="shop-single.html"><img src="static/img/shop/products/26.jpg" alt="Product"></a>
                <h3 class="product-title"><a href="shop-single.html">Ladies BN0111 Sport</a></h3>
                <h4 class="product-price">€140.00</h4>
                <div class="product-buttons">
                  <button class="btn btn-outline-secondary btn-sm btn-wishlist" data-toggle="tooltip" title="Whishlist"><i class="icon-heart"></i></button>
                  <button class="btn btn-outline-primary btn-sm" data-toast data-toast-type="success" data-toast-position="topRight" data-toast-icon="icon-circle-check" data-toast-title="Product" data-toast-message="successfuly added to cart!">Add to Cart</button>
                </div>
              </div>
            </div>
            <!-- Product-->
            <div class="grid-item prestige">
              <div class="product-card"><a class="product-thumb" href="shop-single.html"><img src="static/img/shop/products/28.jpg" alt="Product"></a>
                <h3 class="product-title"><a href="shop-single.html">Gents BN0221 Prestige</a></h3>
                <h4 class="product-price">€435.00</h4>
                <div class="product-buttons">
                  <button class="btn btn-outline-secondary btn-sm btn-wishlist" data-toggle="tooltip" title="Whishlist"><i class="icon-heart"></i></button>
                  <button class="btn btn-outline-primary btn-sm" data-toast data-toast-type="success" data-toast-position="topRight" data-toast-icon="icon-circle-check" data-toast-title="Product" data-toast-message="successfuly added to cart!">Add to Cart</button>
                </div>
              </div>
            </div>
            <!-- Product-->
            <div class="grid-item classic">
              <div class="product-card"><a class="product-thumb" href="shop-single.html"><img src="static/img/shop/products/18.jpg" alt="Product"></a>
                <h3 class="product-title"><a href="shop-single.html">Gents BN0142 Classic</a></h3>
                <h4 class="product-price">€215.00</h4>
                <div class="product-buttons">
                  <button class="btn btn-outline-secondary btn-sm btn-wishlist" data-toggle="tooltip" title="Whishlist"><i class="icon-heart"></i></button>
                  <button class="btn btn-outline-primary btn-sm" data-toast data-toast-type="success" data-toast-position="topRight" data-toast-icon="icon-circle-check" data-toast-title="Product" data-toast-message="successfuly added to cart!">Add to Cart</button>
                </div>
              </div>
            </div>
            <!-- Product-->
            <div class="grid-item prestige">
              <div class="product-card"><a class="product-thumb" href="shop-single.html"><img src="static/img/shop/products/24.jpg" alt="Product"></a>
                <h3 class="product-title"><a href="shop-single.html">Gents BN0095 Prestige</a></h3>
                <h4 class="product-price">€655.00</h4>
                <div class="product-buttons">
                  <button class="btn btn-outline-secondary btn-sm btn-wishlist" data-toggle="tooltip" title="Whishlist"><i class="icon-heart"></i></button>
                  <button class="btn btn-outline-primary btn-sm" data-toast data-toast-type="success" data-toast-position="topRight" data-toast-icon="icon-circle-check" data-toast-title="Product" data-toast-message="successfuly added to cart!">Add to Cart</button>
                </div>
              </div>
            </div>
            <!-- Product-->
            <div class="grid-item classic">
              <div class="product-card"><a class="product-thumb" href="shop-single.html"><img src="static/img/shop/products/20.jpg" alt="Product"></a>
                <h3 class="product-title"><a href="shop-single.html">Gents BN0032 Classic</a></h3>
                <h4 class="product-price">€185.00</h4>
                <div class="product-buttons">
                  <button class="btn btn-outline-secondary btn-sm btn-wishlist" data-toggle="tooltip" title="Whishlist"><i class="icon-heart"></i></button>
                  <button class="btn btn-outline-primary btn-sm" data-toast data-toast-type="success" data-toast-position="topRight" data-toast-icon="icon-circle-check" data-toast-title="Product" data-toast-message="successfuly added to cart!">Add to Cart</button>
                </div>
              </div>
            </div>
            <!-- Product-->
            <div class="grid-item digital">
              <div class="product-card"><a class="product-thumb" href="shop-single.html"><img src="static/img/shop/products/23.jpg" alt="Product"></a>
                <h3 class="product-title"><a href="shop-single.html">Gents BN0106 Digital</a></h3>
                <h4 class="product-price">€585.00</h4>
                <div class="product-buttons">
                  <button class="btn btn-outline-secondary btn-sm btn-wishlist" data-toggle="tooltip" title="Whishlist"><i class="icon-heart"></i></button>
                  <button class="btn btn-outline-primary btn-sm" data-toast data-toast-type="success" data-toast-position="topRight" data-toast-icon="icon-circle-check" data-toast-title="Product" data-toast-message="successfuly added to cart!">Add to Cart</button>
                </div>
              </div>
            </div>
            <!-- Product-->
            <div class="grid-item sport">
              <div class="product-card"><a class="product-thumb" href="shop-single.html"><img src="static/img/shop/products/27.jpg" alt="Product"></a>
                <h3 class="product-title"><a href="shop-single.html">Ladies BN0111 Sport</a></h3>
                <h4 class="product-price">€140.00</h4>
                <div class="product-buttons">
                  <button class="btn btn-outline-secondary btn-sm btn-wishlist" data-toggle="tooltip" title="Whishlist"><i class="icon-heart"></i></button>
                  <button class="btn btn-outline-primary btn-sm" data-toast data-toast-type="success" data-toast-position="topRight" data-toast-icon="icon-circle-check" data-toast-title="Product" data-toast-message="successfuly added to cart!">Add to Cart</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
</template>

<script>
export default {};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/grid.vue